export default __webpack_public_path__ + "c8e2134ad007cee3ce1b2d1966195a8c.png";